export default "__VITE_ASSET__hHIN1luf__"